module.exports = __webpack_public_path__ + "img/button1.c2842919.png";